import React from "react";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { createReferralBonusAsync, updateReferralBonusAsync } from "../../redux/referralBonusApi";
import { useDispatch } from "react-redux";
import { CircularProgress } from "@material-ui/core";
import { Col, Row, Modal } from "react-bootstrap";

const AddReferralBonus = ({ selectedReferral, isLoading, showReferralModal, setShowReferralModal }) => {
  const dispatch = useDispatch();

  const AddReferralFormSchema = () =>
    Yup.object().shape({
      referralBonusCoins: Yup.number().min(1, "Must be at least 1").required("Referral Bonus Coins is required"),
      referralSignUpBonus: Yup.number().min(1, "Must be at least 1").required("Referral Sign-Up Bonus is required"),
    });

  const onHideModal = () => {
    setShowReferralModal(false);
  };

  return (
    <>
      <Modal show={showReferralModal} onHide={() => onHideModal()} centered className="def_modal delete_modal" enforceFocus={false}>
        <Modal.Header closeButton>
          <Modal.Title className="fn_s_18 color_blk f-w-700">
            {selectedReferral && selectedReferral._id ? "Edit Referral Bonus Coins" : "Add Referral Bonus Coins"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Formik
            enableReinitialize
            initialValues={{
              referralBonusCoins: (selectedReferral && selectedReferral.referralBonusCoins) || 100,
              referralSignUpBonus: (selectedReferral && selectedReferral.referralSignUpBonus) || 50,
            }}
            validationSchema={AddReferralFormSchema}
            onSubmit={(values) => {
              if (!selectedReferral || !selectedReferral._id) {
                dispatch(createReferralBonusAsync(values, setShowReferralModal));
              } else {
                dispatch(updateReferralBonusAsync(selectedReferral._id, values, setShowReferralModal));
              }
            }}
          >
            {({ values, errors, touched, handleChange, handleSubmit }) => (
              <Form onSubmit={handleSubmit}>
                <Row className="justify-content-center">
                  <Col lg={12}>
                    <div className="form-group">
                      <label className="form-label text-white font-size-12px inter-font font-weight-normal">Referral Bonus Coins</label>
                      <input
                        placeholder="Enter Referral Bonus Coins"
                        type="number"
                        name="referralBonusCoins"
                        value={values.referralBonusCoins}
                        className={errors.referralBonusCoins && touched.referralBonusCoins ? "form-control re_inputRouded is-invalid border-less-input" : "form-control re_inputRouded border-less-input"}
                        onChange={handleChange}
                      />
                      {touched.referralBonusCoins && errors.referralBonusCoins ? (
                        <div className="fv-plugins-message-container">
                          <div className="fv-help-block">{errors.referralBonusCoins}</div>
                        </div>
                      ) : null}
                    </div>

                    <div className="form-group">
                      <label className="form-label text-white font-size-12px inter-font font-weight-normal">Referral Sign-Up User Bonus</label>
                      <input
                        placeholder="Enter Referral Sign-Up User Bonus"
                        type="number"
                        name="referralSignUpBonus"
                        value={values.referralSignUpBonus}
                        className={errors.referralSignUpBonus && touched.referralSignUpBonus ? "form-control re_inputRouded is-invalid border-less-input" : "form-control re_inputRouded border-less-input"}
                        onChange={handleChange}
                      />
                      {touched.referralSignUpBonus && errors.referralSignUpBonus ? (
                        <div className="fv-plugins-message-container">
                          <div className="fv-help-block">{errors.referralSignUpBonus}</div>
                        </div>
                      ) : null}
                    </div>

                    <div className="form-group mb-0 mt-4">
                      <div className="form-group mr-5 mb-1 mt-2">
                        <button type="submit" className="btn btn-blue spinnerBtn add-avtar-btn" disabled={isLoading}>
                          <span>{selectedReferral && selectedReferral._id ? "Update" : "Add"}</span>
                          {isLoading && (
                            <div className="ml-3 basic-verification-loader text-center">
                              <CircularProgress />
                            </div>
                          )}
                        </button>
                      </div>
                    </div>
                  </Col>
                </Row>
              </Form>
            )}
          </Formik>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default AddReferralBonus;
